import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  container: {
    paddingLeft: "30px",
    paddingRight: "30px",
    backgroundColor: theme.colors.gray[2],
    borderRadius: "4px",
    width: "100%",
    height: "fit-content",
  },
  btnSubmitVoucher: {
    backgroundColor: theme.colors.gray[6],
    width: "100px",
    height: "100%",
    borderRadius: "4px",
    paddingRight: "10px",
    paddingLeft: "10px",
    color: theme.white,
  },
  titlSection: {
    fontSize: theme.headings.sizes.h6,
  },
  centerBoxUnderline: {
    paddingTop: "10px",
    paddingBottom: "10px",
    borderBottom: `1px solid ${theme.colors.gray[4]}`,
  },
  centerBoxUnderlineSpaceBT: {
    paddingTop: "10px",
    paddingBottom: "10px",
    justifyContent: "space-between",
    display: "flex",
    height: "fit-content",
    flex: 1,
  },
}));

export default useStyles;
